import { Injectable } from '@angular/core';
import { WrapperHttpService } from '../../../../../services/wrapper-http-service';
import { Observable } from 'rxjs';
import { DockItemURIParams, DockOverview } from '../../models';
import { API_URL } from '../../../../../../services/config';
import { DockEndpoint } from '../../constants/dock-endpoint';
import { CompartmentEndpoint } from '../../../compartment/constants/compartment-endpoint';
import { HubEndpoint } from '../../../hub/constants/hub-endpoint';

@Injectable({
  providedIn: 'root',
})
export class DockOverviewService {
  constructor(private http: WrapperHttpService) {}

  getOverviewData({ hubId, dockId, compartmentId }: DockItemURIParams): Observable<DockOverview> {
    return this.http
      .withLoading()
      .get<DockOverview>(
        `${API_URL}${HubEndpoint.Base}/${hubId}${CompartmentEndpoint.Base}/${compartmentId}${DockEndpoint.Base}/${dockId}`,
      );
  }
}
